import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl_SPB } from "../../BaseUrl";
import { useAuth } from "../../AuthProvider";

export default function StripeConnectScreen() {

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const authContext = useAuth();

  /**
   * STEP 1: Start Stripe onboarding
   */
  const handleConnect = async () => {
    try {
      setLoading(true);

      const headers = {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + authContext.token
      };

      // Call YOUR backend (same pattern as Basiq)
      const res = await axios.post(
        `${baseUrl_SPB}/api/v1/stripe/connect`,
        {},
        { headers }
      );

      const onboardingUrl = res.data;

      // Redirect to Stripe hosted onboarding
      window.open(onboardingUrl, "_blank");

    } catch (err) {
      console.error("Stripe connect failed:", err);
    } finally {
      setLoading(false);
    }
  };


  /**
   * STEP 2: Check Stripe status (UI state)
   */
  const fetchStatus = async () => {
    try {

      const headers = {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + authContext.token
      };

      const res = await axios.get(
        `${baseUrl_SPB}/api/v1/stripe/status`,
        { headers }
      );

      setStatus(res.data);

    } catch (err) {
      console.error("Failed to fetch Stripe status:", err);
    }
  };


  /**
   * STEP 3: Refresh after Stripe redirect
   * (call this on page load if user came back from Stripe)
   */
  const refreshStatus = async () => {
    try {

      const headers = {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + authContext.token
      };

      await axios.post(
        `${baseUrl_SPB}/api/v1/stripe/refresh`,
        {},
        { headers }
      );

      await fetchStatus();

    } catch (err) {
      console.error("Stripe refresh failed:", err);
    }
  };


  /**
   * Auto-check status on load
   */
  useEffect(() => {
    fetchStatus();
  }, []);


  return (
    <div style={{ padding: 20 }}>

      <h2>Accept Card Payments (Stripe)</h2>

      {/* STATUS UI */}
      {status && (
        <div style={{ marginBottom: 20 }}>
          <p><b>Status:</b></p>

          <p>Charges Enabled: {status.chargesEnabled ? "✅" : "❌"}</p>
          <p>Payouts Enabled: {status.payoutsEnabled ? "✅" : "❌"}</p>
          <p>Details Submitted: {status.detailsSubmitted ? "✅" : "❌"}</p>

          <p>
            <b>
              {status.onboardingComplete
                ? "Ready to accept payments"
                : "Setup required"}
            </b>
          </p>
        </div>
      )}

      {/* CONNECT BUTTON */}
      {!status?.onboardingComplete && (
        <button onClick={handleConnect} disabled={loading}>
          {loading ? "Redirecting..." : "Enable Card Payments"}
        </button>
      )}

      {/* REFRESH BUTTON (optional manual recovery) */}
      {status && !status.onboardingComplete && (
        <button
          onClick={refreshStatus}
          style={{ marginLeft: 10 }}
        >
          I completed Stripe setup
        </button>
      )}

    </div>
  );
}